export const MAX_FREE_COUNT = 3
export const PREMIUM_PRICE_MONTH = 2.99
export const PRO_PRICE_MONTH = 5.99